module.exports = __webpack_public_path__ + "brandon_blk_it-webfont.bf408e96bc034e1f27c1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_blk_it-webfont.woff2
// module id = 938
// module chunks = 7